import React from 'react';

const MessageActions = ({ message, messageFeedback, onFeedback, onCopy }) => {
  const ActionButton = ({ icon, onClick, active, activeColor, activeBg }) => (
    <button
      onClick={onClick}
      className={`message-action-btn ${active ? 'active' : ''}`}
      style={{
        backgroundColor: active ? activeBg : 'transparent',
        color: active ? activeColor : '#64748b',
      }}
    >
      <i className={icon} style={{ fontSize: '15px' }} />
    </button>
  );

  return (
    <div className="message-actions">
      <ActionButton
        icon="fa-regular fa-thumbs-up"
        onClick={() => onFeedback(message.id, messageFeedback[message.id] === 'like' ? null : 'like')}
        active={messageFeedback[message.id] === 'like'}
        activeColor="#16a34a"
        activeBg="#dcfce7"
      />
      <ActionButton
        icon="fa-regular fa-thumbs-down"
        onClick={() => onFeedback(message.id, messageFeedback[message.id] === 'dislike' ? null : 'dislike')}
        active={messageFeedback[message.id] === 'dislike'}
        activeColor="#dc2626"
        activeBg="#fef2f2"
      />
      <button
        className="message-action-btn copy-btn"
        onClick={(e) => {
          const iconElement = e.currentTarget.querySelector('i');
          onCopy(message.content, e.currentTarget, iconElement);
        }}
      >
        <i className="fa-regular fa-copy" style={{ fontSize: '13px' }} />
      </button>
    </div>
  );
};

export default MessageActions;

